import { RotatedTitle } from '../../../../components/rotated-title/rotated-title'
import DmsReserve from '../../../../components/editable-cell/form-items/dms-reserve'
import { hasDmsInFinishing } from '../../../../helpers/is-dms-machine'
import { isDurstMachine } from '../../../../helpers/is-durst-machine'
import { DataSourceItem } from '../../helpers/convert-calculations-to-data-source'
import { isColorProofDurstRollout } from '../../helpers/color-proof-branch'
import isCalculation from '../../helpers/is-calculation'
import type { CalculationColumn } from '../../types/column-types'

export const dmsReserveColumn: CalculationColumn = {
    dataIndex: 'dmsReserve',
    title: <RotatedTitle>Запас DMS</RotatedTitle>,
    width: 30,
    editable: true,
    FormItem: <DmsReserve />,
    onCell: (record: DataSourceItem) => {
        if (isCalculation(record)) {
            return { colSpan: 0 }
        }
        return {
            colSpan: 1,
            editable:
                isDurstMachine(record.machine) &&
                hasDmsInFinishing(record.additional_machines) &&
                !isColorProofDurstRollout(record),
        }
    },
}
